import { useEffect, useState } from "react";
import api from "../lib/api";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ItemsShowcase from "../components/ItemsShowcase";
import Gallery from "../components/Gallery";
import About from "../components/About";
import ReservationForm from "../components/ReservationForm";
import Footer from "../components/Footer";
import { Star } from "lucide-react";

export default function Home() {
  const [content, setContent] = useState(null);
  const [items, setItems] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [c, i, g, r] = await Promise.all([
          api.getContent(), api.getItems(), api.getGallery(), api.getReviews(),
        ]);
        setContent(c.data?.data || c.data); setItems(i.data || []); setGallery(g.data || []); setReviews(r.data || []);
      } catch (e) { console.error(e); } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-cream"><div className="title-pop text-3xl" style={{ color: "var(--ff-peach)" }}>A carregar...</div></div>;

  return (
    <div className="bg-cream">
      <Header content={content} />
      <main>
        <Hero content={content} />
        <ItemsShowcase content={content} items={items} />
        <Gallery content={content} images={gallery} />
        
        {reviews.length > 0 && (
          <section className="py-16 md:py-20 bg-cream">
            <div className="max-w-5xl mx-auto px-5">
              <div className="text-center mb-10">
                <span className="inline-block font-display text-sm font-semibold tracking-[0.2em] uppercase mb-2" style={{ color: "var(--ff-peach)" }}>
                  Depoimentos
                </span>
                <h2 className="title-pop text-4xl md:text-5xl" style={{ color: "var(--ff-text)" }}>
                  O que dizem os nossos clientes
                </h2>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                {reviews.slice(0, 4).map((rv) => (
                  <div key={rv.id} className="frame-scallop" style={{ "--frame-color": rv.color || "#F5B0B0" }}>
                    <div className="frame-inner p-6">
                      <div className="flex items-start justify-between mb-3">
                        <div>
                          <p className="font-bold text-lg" style={{ color: "var(--ff-text)" }}>{rv.customer_name}</p>
                          <p className="text-sm" style={{ color: "var(--ff-text-soft)" }}>{rv.item_name} • {rv.event_date}</p>
                        </div>
                      </div>
                      <div className="flex gap-1 mb-3">
                        {[1, 2, 3, 4, 5].map((n) => (
                          <Star key={n} size={20} fill={n <= rv.rating ? "#F59E0B" : "none"} color={n <= rv.rating ? "#F59E0B" : "#cbd5e1"} strokeWidth={1.5} />
                        ))}
                      </div>
                      {rv.comment ? (
                        <p className="font-body text-base leading-relaxed" style={{ color: "var(--ff-text-soft)" }}>"{rv.comment}"</p>
                      ) : (
                        <p className="text-sm italic text-slate-400">Sem comentário</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
        
        <About content={content} />
        <ReservationForm content={content} items={items} />
      </main>
      <Footer content={content} />
    </div>
  );
}
